import React from 'react'

function Header() {
  return (
    <>
    <div className='shadow shadow-gray-200'>
    <h1 className="text-gray-800 text-3xl p-1 m-4 font-bold text-center">APP BIKE</h1>
    </div>
    </>
  )
}

export default Header